import create from "zustand"

const useHeaderStore = create(set => ({
    showHeader: true,
    setShowHeader: showHeader => set({ showHeader }),
}))

export default useHeaderStore
